﻿export const totalCartItems = (cartitems) => {
    let totalItems = 0;

    cartitems.forEach(function(cartItem) {
        const isNavInkItem = cartItem.purchaseProcess === 30;
        const isNavInkItemWithLotQty = (isNavInkItem && cartItem.lotQty);

        if (isNavInkItemWithLotQty) {
            totalItems++;
        }
        else {
            totalItems += cartItem.qty;
        }
    });

    return totalItems;
}